fragment ChatAgent on User {
    id
    agentStatus
    numActiveChats
    numNeedsReplyChats
    name
    agentPresence
}
